"use client";
import React from "react";
import StartTrialBtn from "../StartTrialBtnProducts";
import IndustryComponent from "@/component/Manufacturing/IndustryComponent";
import WhatWeBanner1 from "@/component/Manufacturing/WhatweBanner";
import Image from "next/image";
import discoveryGoalSettingIco from "@/Helper/images/discovery_goal_setting.svg";
import DataIntegrationPreparationIco from "@/Helper/images/data_integration_preparation.svg";
import InsightGenerationPredictiveModeling from "@/Helper/images/insight_generation_predictive_modeling.svg";
import ActionableImplementationTrainingIco from "@/Helper/images/actionable_implementation_training.svg";
import ContinuousSupportImprovementIco from "@/Helper/images/continuous_support_improvement.svg";
// Rest of your component...

const Manufacturing = () => {


  return (
    <>
      <section className="banner_bg1 manufacturing_indus_bg">
        <div className="container banner_container1">
          <div className="banner_inner">
            <div className="banner_left">
              <h1 className="banner_heading1">
                Empowering manufacturing with data-driven precision
              </h1>
              <p className="banner_text1">
                We bring advanced data analytics solutions to manufacturers, helping them optimize processes, reduce costs, and improve quality control for a smarter, more agile operation.
              </p>
              <div className="banner_btn_container">
                <StartTrialBtn Text={"Get Started Today"} />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about_topsect">
        <div className="container">
          <div className="about_topsectinner">
            <div className="common_titbox">
              <h2 className="common_hd">What we offer</h2>
              <p className="common_desc">
                Our specialized data analytics services target the critical areas of manufacturing, enhancing productivity,sustainability, and competitive advantage. Here’s how we support your manufacturing goals
              </p>
            </div>
          </div>
        </div>
      </section>
      <WhatWeBanner1 />

      <section className="comm_indusreiessection Casestudies_indusreies">
        <div className="container">
          <div className="common_titbox common_titboxcenter">
            <h2 className="common_hd">Case studies</h2>
            <p className="common_desc">
              We’re proud to have delivered measurable success for manufacturers across diverse sectors.<br />
              Here’s how our analytics have transformed operations for some of our clients
            </p>
          </div>
          <div className="indus_inner">
            <div className="indus_list_case">
              <h2 className="indus_hd1">
                Reducing Downtime by 25% for an Automotive Parts Manufacturer
              </h2>
              <p className="indus_desc1">
                By implementing predictive maintenance, we reduced equipment failures, enabling this client to cut unplanned downtime by 25%, saving millions in operational costs annually
              </p>
            </div>
            <div className="indus_list_case">
              <h2 className="indus_hd1">
                Improving Yield by 15% for a Chemical Manufacturer
              </h2>
              <p className="indus_desc1">
                Our analytics solution identified production inefficiencies and quality control issues, resulting in a 15% increase in yield and a 10% reduction in scrap materials.
              </p>
            </div>
            <div className="indus_list_case">
              <h2 className="indus_hd1">
                Lowering Energy Consumption by 20% for a Metal Fabrication Plant
              </h2>
              <p className="indus_desc1">
                By analyzing energy use across shifts and departments, we helped this plant implement energy-saving measures that reduced consumption by 20%, meeting sustainability targets and reducing costs.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="comm_indusreiessection">
        <div className="container">
          <div className="common_titbox common_titboxcenter">
            <h2 className="common_hd">Why choose iKnot?</h2>
          </div>
          <div className="indus_chooseinner">

            <div className="indus_chooselist indus_chooselist1">
              <h3 className="indus_hd1">Manufacturing expertise</h3>
              <p className="indus_desc1">
                We understand the manufacturing industry’s unique challenges and bring solutions that improve efficiency, reliability, and quality control for sustainable growth.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist2">
              <h3 className="indus_hd1">Proven track record</h3>
              <p className="indus_desc1">
                Our analytics solutions deliver measurable results, from cost reduction and increased yield to improved machine uptime and quality consistency.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist3">
              <h3 className="indus_hd1">Comprehensive, end-to-end service</h3>
              <p className="indus_desc1">
                We provide full-service analytics, from data integration to insight generation and implementation, ensuring your manufacturing operation benefits at every stage.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist4">
              <h3 className="indus_hd1">Security & compliance</h3>
              <p className="indus_desc1">
                We prioritize data security and industry compliance, giving you the peace of mind that your production data is protected and meets regulatory standards.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist5">
              <h3 className="indus_hd1">Scalable, custom solution</h3>
              <p className="indus_desc1">
                Our analytics solutions are designed to adapt to your changing needs, providing value that grows with your operation as you scale and expand.
              </p>
            </div>
          </div>
        </div>
      </section> */}
   
      <section className="why_hireapp">
        <div className="container">
          <div className="why_hireappinner">
            <div className="why_hireleft">
              <div className="common_titbox">
                <h2 className="common_hd">Our Approach</h2>
                <p className="common_desc">Our data-driven approach to manufacturing empowers businesses to optimize processes, enhance
                  productivity, and stay ahead in a competitive market.</p>
              </div>
            </div>
            <div className="why_hirergt">
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={discoveryGoalSettingIco}
                    alt="Precision Problem Solving"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Precision Problem Solving</h3>
                  <p className="bx_rightdesc">We begin with an in-depth analysis of your manufacturing processes to
                    identify pain points and opportunities. By aligning with your operational goals, we create a tailored
                    strategy to address challenges and boost efficiency.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={DataIntegrationPreparationIco}
                    alt="Data Fusion for Excellence"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Data Fusion for Excellence</h3>
                  <p className="bx_rightdesc">Manufacturing data often exists in silos. We unify data from production
                    systems, supply chain platforms, quality control processes, and more, creating a centralized hub that
                    drives clarity and precision.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={InsightGenerationPredictiveModeling}
                    alt="Predict, Prevent, Perform"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Predict, Prevent, Perform</h3>
                  <p className="bx_rightdesc">Our advanced predictive models leverage AI and IoT to anticipate
                    maintenance needs, optimize production schedules, and forecast market demand. This proactive
                    approach helps minimize disruptions and maximize output.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={ActionableImplementationTrainingIco}
                    alt="Real-Time Actionability"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Real-Time Actionability</h3>
                  <p className="bx_rightdesc">Through intuitive dashboards and real-time analytics, we enable on-the-spot
                    decision-making. Whether on the factory floor or in the boardroom, our tools empower your team
                    to act swiftly and effectively.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={ContinuousSupportImprovementIco}
                    alt="Continuous Innovation Partnership"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Continuous Innovation Partnership</h3>
                  <p className="bx_rightdesc">Manufacturing is ever-evolving, and so are we. Our solutions
                    include ongoing support, iterative improvements, and insights on emerging trends to ensure your
                    business remains a leader in the industry.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="industry_bg1">
        <div className="container industry_containerouter1">
          <div className="common_titbox common_titboxcenter"><h2 className="common_hd">Why Choose iKnot?</h2>
          </div>
          <IndustryComponent />
        </div>
      </section>
      <section className="cta_outer manufacturingcta_bg">
        <div className="container cta_container">
          <div className="cta_inner">
            <div className="cta_innerout1">
              <div className="cta_left1">
                <h3 className="cta_hd">
                Ready to transform your manufacturing operations with data analytics?
                </h3>
                <p className="cta_desc">
                Get in touch with our experts to learn how our solutions can help you optimize production, reduce costs, and achieve greater efficiency in every area of your manufacturing process.</p>
                <div className="banner_btn_container">
                  <StartTrialBtn Text={"Get Started"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Manufacturing;
